import { useContext } from 'react';

import { ApplicationContext } from '../../../../shared/source/context/context';
import { PrimaryActionButton } from '../../design/components/button/PrimaryAction';
import { ErrorPage } from '../../design/components/errors/ErrorPage';

import type { FunctionComponent } from 'react';

export const Error400: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={400}
            message={translate('errors.status.400.message')}
            title={translate('errors.status.400.title')}
        >
            <PrimaryActionButton
                label={translate('errors.status.400.action')}
                variant="contained"
                onClick={() => actions.navigateTo('/dashboard')}
            />
        </ErrorPage>
    );
};

export const Error403: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={403}
            message={translate('errors.status.403.message')}
            title={translate('errors.status.403.title')}
        >
            <PrimaryActionButton
                label={translate('errors.status.403.action')}
                variant="contained"
                onClick={() => actions.navigateTo('/dashboard')}
            />
        </ErrorPage>
    );
};

export const Error404: FunctionComponent = () => {
    const { actions, translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={404}
            message={translate('errors.status.404.message')}
            title={translate('errors.status.404.title')}
        >
            <PrimaryActionButton
                label={translate('errors.status.404.action')}
                variant="contained"
                onClick={() => actions.navigateTo('/dashboard')}
            />
        </ErrorPage>
    );
};

export const Error500: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return (
        <ErrorPage
            errorCode={500}
            message={translate('errors.status.500.message')}
            title={translate('errors.status.500.title')}
        >
            <PrimaryActionButton
                label={translate('errors.status.500.action')}
                variant="contained"
                onClick={() => globalThis.location.reload()}
            />
        </ErrorPage>
    );
};
